<template>
    <component
        :is="type"
        class="ds-table__cell"
        :class="{
            'ds-table__cell--th': type === 'th',
            'ds-table__cell--ordered': enableOrdering,
            'ds-table__cell--active': isOrderingActive,
            'ds-table__cell--desc': isOrderDesc,
        }"
        :scope="type === 'th' ? 'col' : null"
    >
        <div v-if="enableOrdering" class="ds-table__cell-content ds-table__cell-content--ordered">
            <slot></slot>
            <DsIcon name="chevron-up" />
        </div>
        <template v-else>
            <slot></slot>
        </template>
    </component>
</template>

<script lang="ts" setup>
import DsIcon from "../icon/ds-icon.vue";

withDefaults(
    defineProps<{
        /**
         * Set type of cell
         */
        type?: "td" | "th";

        /**
         * Tells if ordering should be enabled
         */
        enableOrdering?: boolean;

        /**
         * Tells if ordering is active on current cell
         */
        isOrderingActive?: boolean;

        /**
         * Tells if current order is descending
         */
        isOrderDesc?: boolean;
    }>(),
    {
        type: "td",
        enableOrdering: false,
        isOrderingActive: false,
        isOrderDesc: false,
    }
);
</script>
